var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8896_189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8896_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 15.875C10.1776 15.875 10.326 15.8151 10.4456 15.6952C10.5653 15.5755 10.6252 15.4271 10.6252 15.25V11.7083C10.6252 11.5312 10.5652 11.3828 10.4454 11.2629C10.3255 11.1432 10.177 11.0833 9.99995 11.0833C9.82273 11.0833 9.67433 11.1432 9.55475 11.2629C9.43502 11.3828 9.37516 11.5312 9.37516 11.7083V15.25C9.37516 15.4271 9.43509 15.5755 9.55496 15.6952C9.67482 15.8151 9.82329 15.875 10.0004 15.875ZM10.0002 9.65708C10.1909 9.65708 10.3507 9.59257 10.4797 9.46354C10.6088 9.33451 10.6733 9.17465 10.6733 8.98396C10.6733 8.79326 10.6088 8.6334 10.4797 8.50438C10.3507 8.37549 10.1909 8.31104 10.0002 8.31104C9.80947 8.31104 9.64961 8.37549 9.52058 8.50438C9.39155 8.6334 9.32704 8.79326 9.32704 8.98396C9.32704 9.17465 9.39155 9.33451 9.52058 9.46354C9.64961 9.59257 9.80947 9.65708 10.0002 9.65708ZM10.0016 19.8333C8.90662 19.8333 7.87738 19.6256 6.91391 19.21C5.95044 18.7944 5.11238 18.2305 4.39975 17.5181C3.68711 16.8058 3.12287 15.9681 2.70704 15.005C2.29134 14.0419 2.0835 13.013 2.0835 11.9181C2.0835 10.8231 2.29127 9.79389 2.70683 8.83042C3.12238 7.86694 3.68634 7.02889 4.3987 6.31625C5.11107 5.60361 5.94877 5.03937 6.91183 4.62354C7.87489 4.20785 8.90384 4 9.9987 4C11.0937 4 12.1229 4.20778 13.0864 4.62333C14.0499 5.03889 14.8879 5.60285 15.6006 6.31521C16.3132 7.02757 16.8775 7.86528 17.2933 8.82833C17.709 9.79139 17.9168 10.8203 17.9168 11.9152C17.9168 13.0102 17.7091 14.0394 17.2935 15.0029C16.8779 15.9664 16.314 16.8044 15.6016 17.5171C14.8893 18.2297 14.0516 18.794 13.0885 19.2098C12.1254 19.6255 11.0965 19.8333 10.0016 19.8333ZM10.0002 18.5833C11.8613 18.5833 13.4377 17.9375 14.7293 16.6458C16.021 15.3542 16.6668 13.7778 16.6668 11.9167C16.6668 10.0556 16.021 8.47917 14.7293 7.1875C13.4377 5.89583 11.8613 5.25 10.0002 5.25C8.13905 5.25 6.56266 5.89583 5.271 7.1875C3.97933 8.47917 3.3335 10.0556 3.3335 11.9167C3.3335 13.7778 3.97933 15.3542 5.271 16.6458C6.56266 17.9375 8.13905 18.5833 10.0002 18.5833Z",
    fill: "#996CFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.36cafb9e88cfcda1cd25756e87aa5312.svg";
export { ForwardRef as ReactComponent };